import { createAction } from "@reduxjs/toolkit";
import { SiteState } from "../types/SiteState";

export const setInitVisibility = createAction<SiteState>(
  "site/setInitVisibility",
);
